module.exports = __webpack_public_path__ + "static/media/picture-(160).48949d7d.JPG";